import React from 'react';
import EvaluationCriteria from '../EvaluationCriteria/EvaluationCriteria';
import EvaluationSubmission from '../EvaluationSubmission/EvaluationSubmission';
import EvaluationFieldwork from '../EvaluationFieldwork/EvaluationFieldwork';
import EvaluationReview from '../EvaluationReview/EvaluationReview';

const EvaluationFactoryComponent = ({
    account,
    session,
    clients,
    factor,
    type,
    currentStep,
    currentSubPage,
    maxSubPage,
    setCurrentStep,
    setCurrentSubPage,
    setMaxSubPage,
    answerFactor,
    setAnswerFactor,
    setStepInComplete,
    setSubPageInComplete,
    validationMessage,
    setValidationMessage
}) => {
    switch (type) {
        case 'Fieldwork':
            return (
                <EvaluationFieldwork
                    answerFactor={answerFactor}
                    setAnswerFactor={setAnswerFactor}
                    account={account}
                    session={session}
                    clients={clients}
                    setMaxSubPage={setMaxSubPage}
                    setSubPageInComplete={setSubPageInComplete}
                    setValidationMessage={setValidationMessage}
                />
            );
        case 'Evaluation':
            return (
                <EvaluationCriteria
                    account={account}
                    session={session}
                    factor={factor}
                    currentStep={currentStep}
                    currentSubPage={currentSubPage}
                    maxSubPage={maxSubPage}
                    setCurrentStep={setCurrentStep}
                    setCurrentSubPage={setCurrentSubPage}
                    setMaxSubPage={setMaxSubPage}
                    answerFactor={answerFactor}
                    setAnswerFactor={setAnswerFactor}
                    setStepInComplete={setStepInComplete}
                    setSubPageInComplete={setSubPageInComplete}
                    setValidationMessage={setValidationMessage}
                />
            );
        case 'Review':
            return (
                <EvaluationReview
                    account={account}
                    session={session}
                    factor={factor}
                    summaryAnswer={answerFactor}
                    currentStep={currentStep}
                    currentSubPage={currentSubPage}
                    maxSubPage={maxSubPage}
                    setCurrentStep={setCurrentStep}
                    setCurrentSubPage={setCurrentSubPage}
                    setMaxSubPage={setMaxSubPage}
                    setStepInComplete={setStepInComplete}
                    setSubPageInComplete={setSubPageInComplete}
                    setValidationMessage={setValidationMessage}
                />
            );
        case 'Submission':
            return (
                <EvaluationSubmission
                    account={account}
                    session={session}
                    answerFactor={answerFactor}
                    setAnswerFactor={setAnswerFactor}
                    currentStep={currentStep}
                    currentSubPage={currentSubPage}
                    maxSubPage={maxSubPage}
                    setCurrentStep={setCurrentStep}
                    setCurrentSubPage={setCurrentSubPage}
                    setMaxSubPage={setMaxSubPage}
                    setStepInComplete={setStepInComplete}
                    setSubPageInComplete={setSubPageInComplete}
                    setValidationMessage={setValidationMessage}
                />
            );
        default:
            return null;
    }
};

export default EvaluationFactoryComponent;
